import React from 'react';
import { CoverImage } from '@leagueplatform/genesis-commons';
import { useIntl } from '@leagueplatform/locales';

export interface ChooseProfilePictureProps {
  photoUrl?: string;
  size: string;
}

export const ChooseProfilePicture = ({
  photoUrl,
  size,
}: ChooseProfilePictureProps): JSX.Element => {
  const { formatMessage } = useIntl();

  return (
    <CoverImage
      src={photoUrl?.length ? photoUrl : ''}
      alt={photoUrl?.length ? formatMessage({ id: 'PROFILE_PHOTO' }) : ''}
      size={size}
      alignSelf="center"
      borderRadius="circle"
      backgroundColor="surface.background.tertiary"
      role={photoUrl ? 'img' : 'presentation'}
    />
  );
};
